import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram } from 'lucide-react';
export function Social() {
  return <section className="py-16 bg-cream border-t border-burgundy/5" data-id="element-197">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-199">
          <h3 className="font-display text-2xl font-bold text-coral mb-8 tracking-widest uppercase" data-id="element-200">
            SÍGUENOS
          </h3>

          <div className="flex justify-center gap-6" data-id="element-201">
            <a href="#" className="group bg-cream-alt hover:bg-coral p-6 rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1" aria-label="Facebook" data-id="element-202">
              <Facebook size={32} className="text-coral group-hover:text-white transition-colors" data-id="element-203" />
            </a>
            <a href="#" className="group bg-cream-alt hover:bg-coral p-6 rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1" aria-label="Instagram" data-id="element-204">
              <Instagram size={32} className="text-coral group-hover:text-white transition-colors" data-id="element-205" />
            </a>
          </div>

          <p className="mt-6 text-charcoal/60 font-medium" data-id="element-206">
            @thehappytaco • Comparte tus momentos felices
          </p>
        </motion.div>
      </div>
    </section>;
}